import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const Investment: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 5C3.23478 5 2.98043 5.10536 2.79289 5.29289C2.60536 5.48043 2.5 5.73478 2.5 6V17C2.5 17.2652 2.60536 17.5196 2.79289 17.7071C2.98043 17.8946 3.23478 18 3.5 18H14.5C14.7652 18 15.0196 17.8946 15.2071 17.7071C15.3946 17.5196 15.5 17.2652 15.5 17V11C15.5 10.4477 15.9477 10 16.5 10C17.0523 10 17.5 10.4477 17.5 11V17C17.5 17.7957 17.1839 18.5587 16.6213 19.1213C16.0587 19.6839 15.2957 20 14.5 20H3.5C2.70435 20 1.94129 19.6839 1.37868 19.1213C0.81607 18.5587 0.5 17.7957 0.5 17V6C0.5 5.20435 0.81607 4.44129 1.37868 3.87868C1.94129 3.31607 2.70435 3 3.5 3H9.5C10.0523 3 10.5 3.44772 10.5 4C10.5 4.55228 10.0523 5 9.5 5H3.5Z"
        fill="#C4FAC3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 1C12.5 0.447715 12.9477 1.49012e-08 13.5 1.49012e-08H19.5C20.0523 1.49012e-08 20.5 0.447715 20.5 1V7C20.5 7.55228 20.0523 8 19.5 8C18.9477 8 18.5 7.55228 18.5 7V2H13.5C12.9477 2 12.5 1.55228 12.5 1Z"
        fill="#C4FAC3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2071 0.292893C20.5976 0.683417 20.5976 1.31658 20.2071 1.70711L9.20711 12.7071C8.81658 13.0976 8.18342 13.0976 7.79289 12.7071C7.40237 12.3166 7.40237 11.6834 7.79289 11.2929L18.7929 0.292893C19.1834 -0.0976311 19.8166 -0.0976311 20.2071 0.292893Z"
        fill="#C4FAC3"
      />
    </svg>
  );
};

export default Investment;
